// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"7cda09a2","55":"70e7423b","437":"70e7423b","447":"70e7423b"}[chunkId] + ".chunk.css";
};